import { useEffect, useRef, useState } from "react";
import React from "react";
import { Form, Input, Button, Select, message, Checkbox, Row, Col } from "antd";
import "./fk-fullpage-contact.css";
import '../../components/confirmation.css'

const { Option } = Select;

export const FullPageContact = () => {
    const [loading, setLoading] = useState(false);
    const [isRegistered, setIsRegistered] = useState(false);
    const [messageApi, contextHolder] = message.useMessage();

    const formRef = useRef(null);
    const containerRef = useRef(null);

    useEffect(() => {
        if (isRegistered) {
            setTimeout(() => {
                window.location.reload()
            }, 5000);
        }
    }, [isRegistered])

    useEffect(() => {
        if (!formRef.current || !containerRef.current) return;

        const updateHeight = () => {
            const formHeight = formRef.current.offsetHeight;
            // containerRef.current.style.minHeight = `${formHeight + 100}px`;
        };

        updateHeight();

        const observer = new ResizeObserver(() => {
            updateHeight();
        });

        observer.observe(formRef.current);

        return () => {
            observer.disconnect();
        };
    }, []);

    const onFinish = (values) => {
        setLoading(true);

        const { rsvp, name, email, phoneNumber, ...rest } = values;

        const signUpData = {
            firstName: name,
            email: email,
            mobile: phoneNumber,
            additionalDetails: {
                rsvp,
                ...rest,
            },
        };

        fetch("https://flipkart-connect-26.wiz365.io/api/auth/signup-wizit", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(signUpData),
        })
            .then((response) => {
                if (!response.ok) {
                    throw new Error(`HTTP error! Status: ${response.status}`);
                }
                return response.json();
            })
            .then(() => {
                messageApi.success("Thank you for registering!");
                setIsRegistered(true);

            })
            .catch(() => {
                messageApi.error("Registration failed. Please try again.");
            })
            .finally(() => {
                setLoading(false);
            });
    };

    const validateEmail = (_, value) => {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (value && !emailRegex.test(value)) {
            return Promise.reject("Invalid email address");
        }
        return Promise.resolve();
    };

    const validatePhoneNumber = (_, value) => {
        const phoneRegex = /^\d{10}$/;
        if (value && !phoneRegex.test(value)) {
            return Promise.reject("Invalid phone number");
        }
        return Promise.resolve();
    };

    return (
        <div ref={containerRef} id="signupsection" className="fk-contact-container">
            {contextHolder}

            <div ref={formRef} className="fk-contact-card">

                <div className="fk-contact-title">
                    {!isRegistered && <h2>SIGN UP TO REGISTER</h2>}
                </div>

                {!isRegistered ? (
                    <Form
                        className="regformbox"
                        name="yourForm"
                        onFinish={onFinish}
                        // onFinishFailed={onFinishFailed}
                        initialValues={{ rsvp: true }}
                        labelCol={{ span: 24 }}
                        wrapperCol={{ span: 24 }}
                    >
                        <Row gutter={16}>
                            <Col xs={24} md={24}>
                                <Form.Item
                                    label={<span style={{ color: "white" }}>Name</span>}
                                    name="name"
                                    rules={[{ required: true, message: "Please enter your name" }]}
                                >
                                    <Input placeholder="Enter your name" />
                                </Form.Item>
                            </Col>

                            <Col xs={24} md={24}>
                                <Form.Item
                                    label={<span style={{ color: "white" }}>Work Email</span>}
                                    name="email"
                                    rules={[
                                        { required: true, message: "Please enter your email" },
                                        { validator: validateEmail },
                                    ]}
                                >
                                    <Input placeholder="Enter your email" />
                                </Form.Item>
                            </Col>

                            <Col xs={24} md={24}>
                                <Form.Item
                                    label={<span style={{ color: "white" }}>Phone Number</span>}
                                    name="phoneNumber"
                                    rules={[
                                        { required: true, message: "Please enter your phone number" },
                                        { validator: validatePhoneNumber },
                                    ]}
                                >
                                    <Input placeholder="Enter your phone number" />
                                </Form.Item>
                            </Col>

                            <Col xs={24} md={24}>
                                <Form.Item
                                    label={<span style={{ color: "white" }}>
                                        Which type of partner do you represent?
                                    </span>}
                                    name="partnerType"
                                    rules={[{ required: true, message: "Please select your partner type" }]}
                                >
                                    <Select placeholder="Select">
                                        <Option value="brand">Brand</Option>
                                        <Option value="agency">Agency</Option>
                                    </Select>
                                </Form.Item>
                            </Col>

                            <Col xs={24} md={24}>
                                <Form.Item
                                    label={<span style={{ color: "white" }}>Organisation Name</span>}
                                    name="organizationName"
                                    rules={[{ required: true, message: "Please enter your organisation name" }]}
                                >
                                    <Input placeholder="Enter your organisation name" />
                                </Form.Item>
                            </Col>

                            <Col xs={24} md={24}>
                                <Form.Item
                                    label={<span style={{ color: "white" }}>
                                        Which brand are you representing?
                                    </span>}
                                    name="brandRepresentation"
                                >
                                    <Input placeholder="Enter the brand name" />
                                </Form.Item>
                            </Col>

                            <Col xs={24}>
                                <Form.Item
                                    name="rsvp"
                                    valuePropName="checked"
                                    rules={[
                                        {
                                            validator: (_, value) =>
                                                value
                                                    ? Promise.resolve()
                                                    : Promise.reject(
                                                        new Error("You must confirm your RSVP")
                                                    ),
                                        },
                                    ]}
                                >
                                    <Checkbox>
                                        I’m confirming my RSVP for Flipkart Connect—see you there!
                                    </Checkbox>
                                </Form.Item>
                            </Col>

                            <Col xs={24} md={24}>
                                <Form.Item
                                    label={<span style={{ color: "white" }}>Email of the POC</span>}
                                    name="pocEmail"
                                    rules={[{ validator: validateEmail }]}
                                >
                                    <Input placeholder="Enter the email of your Flipkart Ads POC" />
                                </Form.Item>
                            </Col>

                            <Col xs={24}>
                                <Form.Item className="text-center">
                                    <Button
                                        type="primary"
                                        className="contactregisterbtn"
                                        htmlType="submit"
                                        loading={loading}
                                    >
                                        {loading ? "Registering..." : "Register"}
                                    </Button>
                                </Form.Item>
                            </Col>
                        </Row>
                    </Form>
                ) : (
                    <div className="fk-thankyou">
                        <div className="text-center">
                            <svg className="checkmark" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52">
                                <circle className="checkmark__circle" cx="26" cy="26" r="25" fill="none" />
                                <path className="checkmark__check" fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8" />
                            </svg>
                        </div>
                        <br />
                        <br />
                        <h3>Thank you for registering!</h3>
                        <p>Your RSVP is confirmed. Please check your email.</p>
                    </div>
                )}
            </div>
        </div>
    );
};